const clientId = '659507812998-lpkpauui51s1ksa84c4qm77ap56tdoge.apps.googleusercontent.com';

export default clientId;
